
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { getPropsFromMeta } from "../../utils"
import CompMeta from '../../meta/LowCodeComponents/ButtonApp';
import "./index.less"

/**
 * @class NCButtonApp
 * @column 1
 * @compType 1
 * @canAppend false
 * @path LowCodeComponents.NCButtonApp
 * @label 按钮组
 *
 */
class NCButtonApp extends Component {
    static propTypes = {
        /**
         * @title 区域编码
         * @description 区域编码
         */
        moduleId: PropTypes.string.isRequired,
        /**
       * @title tabindex
       * @description tabindex
       */
        tabindex: PropTypes.number,
        /**
     * @title 快捷键提示样式
     * @description 快捷键提示样式
     */
        tipKeybodard: PropTypes.string,
        /**
       * @title 自动聚焦
       * @description 自动聚焦
       */
        withAutoFocus: PropTypes.bool,
        /**
        * @title 是否可见
        * @description 是否可见
        */
        visible: PropTypes.bool,
    }
    static getCompMeta() {
        return CompMeta;
    }

    renderComp() {
        const configProps = getPropsFromMeta(this.props, NCButtonApp.getCompMeta());
        const { button, moduleId, config = {}, buttonActions = {}, getButtonActionsByKey, buttonItemsConfig } = this.props;
        const { createButtonApp } = button;
        let { onButtonClick = () => { } } = config;
        let oldButtonClick = onButtonClick;
        onButtonClick = (props, id, hotkey) => {
            //如果业务组已经注册按钮事件，走业务注册事件
            if (buttonItemsConfig[id] && typeof buttonItemsConfig[id].click === "function") {
                buttonItemsConfig[id].click();
            } else {
                // //------预置动作逻辑-------
                // //获取按钮预置动作处理函数数组
                // let btnActionHandlers = getButtonActionsByKey({ ...this.props, btnCode: id });
                // //执行预置动作
                // btnActionHandlers.forEach(handler => handler());
            }
            //执行注册函数
            oldButtonClick(props, id, hotkey);
        }
        config.onButtonClick = onButtonClick;

        return (
            <div className="lc-drop-area button-app">
                {createButtonApp(Object.assign({ area: moduleId, buttonActions }, configProps, config))}
            </div>
        );
    }

    render() {
        return (
            <React.Fragment>
                {this.renderComp()}
            </React.Fragment>
        )
    }
}

export default NCButtonApp;
